import * as api from '../api/mobilehome';
import { makeApiActionCreatorV3 } from '@actions/utils';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';

const namespace = 'APPRAISAL/MOBILEHOME';

export const CHANGE_PAGE = `${namespace}/CHANGE_PAGE`;
export const CHANGE_ROWS_PER_PAGE = `${namespace}/CHANGE_ROWS_PER_PAGE`;
export const CHANGE_FILTER = `${namespace}/CHANGE_FILTER`;

export const MOBILE_HOME_SEARCH = createRequestTypes(
  `${namespace}/MOBILE_HOME_SEARCH`,
);

export const searchMobileHomes = makeApiActionCreatorV3(
  api.searchMobileHomes,
  MOBILE_HOME_SEARCH[START],
  MOBILE_HOME_SEARCH[SUCCESS],
  MOBILE_HOME_SEARCH[ERROR],
);

export const FETCH_MOBILE_HOME_SEARCH_RESULT_CONFIG = createRequestTypes(
  `${namespace}/FETCH_MOBILE_HOME_SEARCH_RESULT_CONFIG`,
);

export const fetchMobileHomeSearchConfig = makeApiActionCreatorV3(
  api.fetchMobileHomeSearchConfig,
  FETCH_MOBILE_HOME_SEARCH_RESULT_CONFIG[START],
  FETCH_MOBILE_HOME_SEARCH_RESULT_CONFIG[SUCCESS],
  FETCH_MOBILE_HOME_SEARCH_RESULT_CONFIG[ERROR],
);

export const changePage = page => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const changeRowsPerPage = rowsPerPage => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const changeFilter = filter => ({
  type: CHANGE_FILTER,
  payload: filter,
});
